export const LENDER_LIVEBOARD_ID: string = 'b9ddcc0b-aab0-4221-97bd-11d6ed11920f' as const;
export const PARTNER_LIVEBOARD_ID: string = '66b7e411-8bd4-43e8-aff5-57910fa82dd5' as const;
export const AFFILIATE_LIVEBOARD_ID: string = '68295ca9-83e2-4897-8ed1-ecf1a84ca1f0' as const;
